import ky from 'ky';
import isEmpty from 'lodash/isEmpty';

const fetchIt = ky.extend({
  prefixUrl: window?.config?.risURL,
  headers: {
    cors: '*cors',
  },
  hooks: {
    beforeRequest: [
      (request) => {
        if (!isEmpty(window.services?.userAuthenticationService)) {
          const headerEntries: [string, string][] = Object.entries(
            window.services?.userAuthenticationService.getAuthorizationHeader()
          );
          for (let i = 0; i < headerEntries.length; i++) {
            request.headers.set(...headerEntries[i]);
          }
        }
      },
    ],
  },
});
export default fetchIt;
